export default "__VITE_ASSET__BC2_GF9___"